import { createContext } from "react";

const ModalsContext = createContext();

export default ModalsContext;